<template>
    <form @submit="register" class="sign-form" autocomplete="off">
        <div class="checkout-panel-column">
            <label class="label-field">
                <span class="field-name">{{ trans('general.fname') }} *</span>
                <input required type="text" v-model="register_data.fname" :placeholder="trans('general.your_fname')" >
            </label>
            <label class="label-field">
                <span class="field-name">{{ trans('general.lname') }} *</span>
                <input required type="text" v-model="register_data.lname" :placeholder="trans('general.your_lname')">
            </label>
            <label class="label-field">
                <span class="field-name">{{ trans('general.mname') }} *</span>
                <input required type="text" v-model="register_data.mname" :placeholder="trans('general.your_mname')">
            </label>
            <label class="label-field">
                <span class="field-name">{{ trans('general.email') }} *</span>
                <input required type="email" v-model="register_data.email" :placeholder="trans('general.your_email')">
            </label>

            <phone-number-input
                v-model="register_data.phone"
                :label="trans('general.phone')+' *'"
                @phone_error="phoneError"
            >
            </phone-number-input>

            <label class="label-field">
                <span class="field-name">{{ trans('passwords.Password') }} *</span>
                <input required type="password" autocomplete="off" v-model="register_data.password" :placeholder="trans('general.your_password')">
            </label>
            <label class="label-field">
                <span class="field-name">{{ trans('passwords.PasswordRepeat') }} *</span>
                <input required type="password" autocomplete="off" v-model="register_data.password_confirmation" :placeholder="trans('passwords.PasswordRepeat')">
            </label>

            
            <span v-if="error" style="color: red" class="register-line">
                {{ error }}
            </span>

            <div class="btn-block">
                <button class="btn" type="submit">
                    {{ trans('auth.register') }}
                </button>
            </div>

            <span class="register-line">
                {{ trans('auth.allready_have_account') }} <a :href="globalVariables.locale + '/login'">{{ trans('auth.enter') }}</a>
            </span>
        </div>
    </form>
</template>
<script>
import axios from "axios";

import helper from "./mixins/helper";
import phoneNumberInput from "./inc/phoneNumberInput";

export default {
    mixins: [
        helper
    ],
    components: {
        'phone-number-input': phoneNumberInput
    },
    props: {
    },
    data() {
        return {
            error: null,
            register_data: {
                fname: null,
                lname: null,
                mname: null,
                email: null,
                phone: null,
                password: null,
                password_confirmation: null
            },
            bindProps: {
                mode: "international",
                enabledFlags: true,
                validCharactersOnly: true,
                inputOptions: {
                    placeholder: this.trans('general.phone'),
                    showDialCode: true
                }
            },
            errors: {
                phone: null
            },
        }
    },
    created() {
    },
    beforeMount() {
        
    },
    mounted() {
    },
    computed: {
        has_error: function() {
            if (Object.values(this.errors).includes(true)) {
                return true;
            } else {
                return false;
            }
        }
    },
    methods: {
        phoneError(error) {
            this.errors.phone = error
        },
        showPassword() {
            let pass = this.$refs.password;
            if(pass.getAttribute('type') == 'password') {
                pass.setAttribute('type', 'text');
            } else {
                pass.setAttribute('type', 'password');
            }
        },
        ckecking() {

            // Simulate input on phone element for see error if it exists
            let event = document.createEvent('Event');
            event.initEvent('input', true, true);
            document.querySelectorAll('.vti__input').forEach(element => {
                element.dispatchEvent(event);
            });

            this.error = null;
            if (this.register_data.password != this.register_data.password_confirmation) {
                this.error = this.trans('auth.error_passwords_not_match');
                return false;
            } else if (this.register_data.password.length < 8) {
                this.error = this.trans('auth.error_passwords_length');
                return false;
            } else {
                return true;
            }
        },
        register(e) {
            e.preventDefault();
            if (this.ckecking() && !this.has_error) {
                axios({
                    method: "post",
                    url: window.globalVariables.locale + "/axio-register",
                    data: this.register_data,
                    config: {
                        headers: {
                            'content-type': 'multipart/form-data'
                        }
                    }
                })
                .then(response => {
                    //console.log(response.data);
                    this.$store.commit('user_data', response.data.user);
                    console.log(this.$store.state.user);
                    location.replace('/');
                })
                .catch(error => {
                    this.error = this.trans('auth.specified_data_has_not_been_verified');
                    console.log(error);
                });
            }
        }
    }
}
</script>